import React, { FC, useRef } from 'react';
import { TransactionsDateFilterDialog } from './TransactionsDateFilterDialog';
import { AdminTableFilterProps } from '../../../components/table/interfaces/AdminTableFilterProps';
import { TransactionsDateFilterContextProvider } from './TransactionsDateFilterContext';
import { TransactionsDateFilterButtons } from './TransactionsDateFilterButtons';
import { TransactionsDateFilterOverlay } from './TransactionsDateFilterOverlay';
import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';

export const TransactionsDateFilter: FC<
  AdminTableFilterProps<TransactionsDateFilterState> & {
    group: TransactionPropertiesGroup;
  }
> = ({ filterFn, group }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <TransactionsDateFilterContextProvider group={group} filterFn={filterFn}>
      <div className="AdminTableDateFilter" ref={containerRef}>
        <TransactionsDateFilterButtons buttonRef={buttonRef} />

        <TransactionsDateFilterOverlay containerRef={containerRef} buttonRef={buttonRef}>
          <TransactionsDateFilterDialog />
        </TransactionsDateFilterOverlay>
      </div>
    </TransactionsDateFilterContextProvider>
  );
};
